import { ProfileEntityFormSchema } from '../../../components/pages/connected/Profile/ProfileEntity/ProfileEntityForm/ProfileEntityForm.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const ENTITY_ENDPOINTS = Object.freeze({
  current: () => api.get(StaticGetEndpoints.CurrentEntity),

  // Pending
  createPending: (data: ProfileEntityFormSchema) =>
    api.post(StaticPostEndpoints.CreatePendingEntity, data),

  currentPending: () => api.get(StaticGetEndpoints.CurrentPendingEntity),
});
